import CourseByIDMooc from "../Portafolio/helpers/CourseByIDMooc";
import { Button, Icon } from 'semantic-ui-react'
import { observer } from "mobx-react-lite";
import Image from 'react-bootstrap/Image';
import { Link } from "react-router-dom";
import "./preguntas_frecuentes.css";
import React, { useEffect, useState } from "react";

import { RegionalBannerCentral } from "../Portafolio/Handlers/RegionalBannerCentral";
import { Col, Container, Row } from "react-bootstrap";
import ModalDialog from 'react-bootstrap/ModalDialog'
import Modal from 'react-bootstrap/Modal';
import Footer from "../Footer";

import icon1 from "../../images/faqs/search-icon.svg";
import icon2 from "../../images/faqs/asignacion-icon.svg";
import icon3 from "../../images/faqs/registro-icon.svg";

import mujer2 from "../../images/faqs/mujer-senalando_dos.png";
import mujer1 from "../../images/faqs/mujer-senalando.png";

import MyIframe from "../PerfilInstitucional/handlers/MyIframe";
import { FloatingWhatsApp } from "../WhatsAppModule";
import { FloatingContact } from "../GenericForms/FloatingContact";

function PreguntasFrecuentes() {

    function RegistroModal(p: {
        show: any,
        onHide: any,
    }) {

        return (
            <Modal
                {...p}
                centered
                fullscreen={true}
                className="modal-faqs"
                aria-labelledby="example-custom-modal-styling-title"
            >

                <Modal.Header closeButton className="close-fix"> </Modal.Header>
                <Modal.Body>
                    {imod}
                    <div id="progress-bar"></div>

                </Modal.Body>
            </Modal>
        );
    }

    
    const [show, setShow] = useState(false);
    const [valMod, setValMod] = useState(0);


    const imod = valMod == 1 ? <MyIframe id={"faqs-iframe"} key={3} src="https://inap.gob.gt/man03/#/"/> 
               : valMod == 2 ? <MyIframe id={"faqs-iframe"} key={1} src="https://inap.gob.gt/man01/#/"/> 
               : <MyIframe id={"faqs-iframe"} key={2} src="https://inap.gob.gt/man02/#/"/> ;

   

    return (

        <>

            <RegionalBannerCentral />
            <Container className="faqs-content-area">

                <Row className="central-content-area">

                    <Col sm={12} lg={7} className="faqs-left">


                        <Row className="faqs-section">
                            <Col sm={1}><img src={icon3} /></Col>
                            <Col sm={11}>
                                <h2>Registro en el portal</h2>
                                <p>Sección que te mostrará el proceso para crear tu cuenta de usuario e ingresar o modificar los datos en tu ficha personal, tales como: No. de Teléfono, Foto, etc.</p>

                                <Button color='blue' animated className="tutorial-btn" onClick={() => { setShow(true); setValMod(1); }}>
                                    <Button.Content visible>Ver tutorial</Button.Content>
                                    <Button.Content hidden>
                                        <Icon name='arrow right' />
                                    </Button.Content>
                                </Button>

                            </Col>
                        </Row>

                        <Row className="faqs-section fqs-2">
                            <Col sm={1}><img src={icon1} /></Col>
                            <Col sm={11}>
                                <h2>Buscar cursos en el Portal</h2>
                                <p>En esta sección aprenderás como puedes utilizar el buscador de cursos o navegar en los distintos catálogos y encontrar cursos que sean de tu interés.</p>

                                <Button color='blue' animated className="tutorial-btn" onClick={() => { setShow(true); setValMod(2); }}>
                                    <Button.Content visible>Ver tutorial</Button.Content>
                                    <Button.Content hidden>
                                        <Icon name='arrow right' />
                                    </Button.Content>
                                </Button>

                            </Col>
                        </Row>

                        <Row className="faqs-section">
                            <Col sm={1}><img src={icon2} /></Col>
                            <Col sm={11}>
                                <h2>Asignación y pago</h2>
                                <p>En esta sección intentaremos responder a todas tus dudas sobre los procesos necesarios para asignarte un curso y realizar el pago correspondiente.</p>

                                <Button color='blue' animated className="tutorial-btn" onClick={() => { setShow(true); setValMod(3); }}>
                                    <Button.Content visible>Ver tutorial</Button.Content>
                                    <Button.Content hidden>
                                        <Icon name='arrow right' />
                                    </Button.Content>
                                </Button>

                            </Col>
                        </Row>

                    </Col>

                    <Col sm={12} lg={5} className="faqs-right">
                        <Image src={mujer1} />
                    </Col>
                </Row>

            </Container>


            <div className="division-section-faqs"></div>

            <Footer />

            <FloatingContact />

            <FloatingWhatsApp
                accountName="INAP Guatemala"
                phoneNumber="+50224198181"
            />

            <RegistroModal
                onHide={() => { setShow(false) }}
                show={show}
            />

        </>

    );

}

export default PreguntasFrecuentes
